module.exports = __webpack_public_path__ + "img/29.7239b251.jpg";